import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { reportTypeDetailed, reportTypeSummary, viewReport } from './common/AcountingConstants'
import { useEffect } from 'react'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getCompanyStateList, getCargoCompanyGSTList, getGSTReturnSummaryReport, getGSTReturnDetailedReport } from '../../../store/Acounting/acounting_action'
import Alert from '../../common/alert'

const GSTReportReturnFile = (props) => {
    const {
        data: { common, acountingReducer },
        getCompanyStateList,
        getCargoCompanyGSTList,
        getGSTReturnSummaryReport,
        getGSTReturnDetailedReport
    } = props
    const { loginData } = common
    const { companystatelist } = acountingReducer
    const reportName = "GST Return File "
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [selReportView, setselReportView] = useState(viewReport[0])
    const [selReportType, setselReportType] = useState(reportTypeSummary[0])
    const [selState, setSelState] = useState()
    const [selGST, setSelGST] = useState()
    const [GSTOpt, setGSTOpt] = useState([])
    const [selBranches, setSelBranches] = useState()
    const [branchOpt, setBranchOpt] = useState([])
    const [includeBranches, setIncludeBranches] = useState(false)
    const [showAlert, setShowAlert] = useState({
        show: false,
        message: ''
    })
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                CompanyID: loginData?.intCompanyID
            }
            getCompanyStateList(body, true, 24 * 60 * 60 * 1000);
        }
    }, [loginData])

    useEffect(() => {
        if (companystatelist.length) {
            setSelState(companystatelist[0])
            getGSTAndBranch(companystatelist[0]?.StateID)
        }
    }, [companystatelist])
    useEffect(() => {
        focusElemnt(id.fromDate)
    }, [])
    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Date', textAlign: 'left' },
        { field: 'reportView', header: 'Report View', textAlign: 'left' },
        { field: 'reportType', header: 'Report Type', textAlign: 'left' },
        { field: 'state', header: 'State', textAlign: 'left' },
        // { field: 'gstIn', header: 'GSTIN', textAlign: 'left' },
        // { field: 'branch', header: 'Branch', textAlign: 'left' },
        // { field: 'includeBranches', header: 'Only GST Branches', textAlign: 'left' },
    ]
    const criteriaData = {
        fromDate: fromDate.format('DD-MM-YYYY'),
        toDate: toDate.format('DD-MM-YYYY'),
        reportView: selReportView?.name,
        reportType: selReportType?.name,
        state: selState?.StateName,
        // gstIn: selGST?.GSTIN || '--All--',
        // branch: selBranches?.BranchName || 'All',
        // includeBranches: includeBranches ? 'Yes' : 'No',
        dataType: 'entry',
    }
    const getGSTAndBranch = (stateID) => {
        setSelGST(' ')
        setSelBranches(' ')
        const body = {
            CompanyID: loginData?.intCompanyID,
            StateID: stateID
        }
        getCargoCompanyGSTList(body).then((res) => {
            if (res.status === 'Success') {
                let gstList = removeDuplicatesFromArray(res?.Data?.Table.map((val) => ({ ...val, GSTIN: val.GSTIN.trim() })), 'GSTIN')
                let branchList = removeDuplicatesFromArray(res?.Data?.Table, "BranchName").filter((val) => val.BranchName !== '')
                setGSTOpt(gstList.length > 0 ? [{ GSTIN: '--All--' }, ...gstList] : gstList)
                setBranchOpt(branchList.length > 0 ? [{ BranchID: 0, BranchName: 'All' }, ...branchList] : branchList)
                if (gstList.length) {
                    setSelGST({ GSTIN: '--All--' })
                }
                if (branchList.length) {
                    setSelBranches({ BranchID: 0, BranchName: 'All' })
                }
            }
        }).catch((err) => {
            console.log('Error:', err)
            setGSTOpt([])
            setBranchOpt([])
        })
    }
    const detailedColumnDefs = [
        { headerName: 'GSTN/UIN of Receipeint', exportHead: 'GSTN/UIN of Receipeint', field: 'ReceipeintGSTIN', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' }, weight: 140, isSortIcon: true },
        { headerName: 'Invoice Number', exportHead: 'Invoice Number', field: 'InvoiceNumber', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, weight: 110, isSortIcon: true },
        { headerName: 'Invoice Date', exportHead: 'Invoice Date', field: 'Invoicedate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, weight: 100, isSortIcon: true },
        { headerName: 'Note Type', exportHead: 'Note Type', field: 'NoteType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, weight: 100, isSortIcon: true },
        { headerName: 'Invoice Value', exportHead: 'Invoice Value', field: 'InvoiceValue', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'right' }, weight: 100, isSortIcon: true },
        { headerName: 'Place of Supply', exportHead: 'Place of Supply', field: 'PlaceofSupply', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, weight: 110, isSortIcon: true },
        { headerName: 'Reverse Charge', exportHead: 'Reverse Charge', field: 'ReverseCharge', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, weight: 100, isSortIcon: true },
        { headerName: 'Invoice Type', exportHead: 'Invoice Type', field: 'InvoiceType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, weight: 80, isSortIcon: true },
        { headerName: 'Rate', exportHead: 'Rate', field: 'Rate', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, weight: 70, isSortIcon: true },
        { headerName: 'Taxable Value', exportHead: 'Taxable Value', field: 'TaxableValue', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '120px', textAlign: 'right' }, weight: 120, isSortIcon: true },
        { headerName: 'IGST', exportHead: 'IGST', field: 'IGST', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, weight: 80, isSortIcon: true },
        { headerName: 'CGST', exportHead: 'CGST', field: 'CGST', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, weight: 80, isSortIcon: true },
        { headerName: 'SGST', exportHead: 'SGST', field: 'SGST', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, weight: 80, isSortIcon: true },
    ]
    const summaryColumnExempDefs = [
        { headerName: 'Description', exportHead: 'Description', field: 'Description', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '300px', textAlign: 'left' }, weight: 300, isSortIcon: true },
        { headerName: 'Nil Rated Supplies', exportHead: 'Nil Rated Supplies', field: 'NilRatedSupplies', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '177px', textAlign: 'right' }, weight: 177, isSortIcon: true },
        { headerName: 'Exempted', exportHead: 'Exempted', field: 'Exempted', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '176px', textAlign: 'right' }, weight: 176, isSortIcon: true },
        { headerName: 'Non-GST Supplies', exportHead: 'NonGSTSupplies', field: 'GST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '177px', textAlign: 'right' }, weight: 177, isSortIcon: true },
    ]
    const summaryColumnDefs = [
        { headerName: 'State As Per GSTN No', exportHead: 'State As Per GSTN No', field: 'StateAsPerGSTNNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '174px', textAlign: 'left' }, weight: 174, isSortIcon: true },
        { headerName: 'Rate', exportHead: 'Rate', field: 'Rate', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '175px', textAlign: 'right' }, weight: 175, isSortIcon: true },
        { headerName: 'Taxable Value', exportHead: 'Taxable Value', field: 'TaxableValue', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '174px', textAlign: 'right' }, weight: 174 , isSortIcon: true},
        { headerName: 'IGST', exportHead: 'IGST', field: 'IGST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '175px', textAlign: 'right' }, weight: 175 , isSortIcon: true},
        { headerName: 'CGST', exportHead: 'CGST', field: 'CGST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '133px', textAlign: 'right' }, weight: 133 , isSortIcon: true},
        { headerName: 'SGST', exportHead: 'SGST', field: 'SGST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '134px', textAlign: 'right' }, weight: 134 , isSortIcon: true},
    ]
    const openViewReport = (reportPayload) => {
        const rid = Date.now().toString()

        if (!window.generatedReports) {
            window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }
    const getMainHeader = (columns = []) =>
        columns.map((column) => {
            const header = column.headerName || column.header || ''
            return {
                ...column,
                header,
                exportHead: column.exportHead || header,
                align: column?.xlCol?.dataType === 'string' ? 'left' : 'right' || column.textAlign || column.align || 'left',
                weight: column?.weight ? column?.weight : 80
            }
        })
    const generateReport = () => {
        const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
        if (diffDays > 31) {
            setShowAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
            return
        }
        const body = {
            CompanyID: loginData?.intCompanyID,
            StateID: selState.StateID,
            FromDate: fromDate.format('YYYY-MM-DD'),
            ToDate: toDate.format('YYYY-MM-DD'),
            Type: selReportType.id,
            BranchWithGSTNOnly: includeBranches ? 1 : 0,
            GSTN: selGST === ' ' ? '--All--' : selGST.GSTIN,
            BranchID: selBranches === ' ' ? 0 : selBranches?.BranchID,
        }
        if (!selReportView.id) {
            getGSTReturnSummaryReport(body).then((res) => {
                if (res.status === 'Success') {
                    if (res?.Data?.Table?.length === 0) {
                        setShowAlert({ show: true, message: 'No Data Found' })
                        return
                    }
                    let data = res?.Data?.Table?.map((val, i) => ({
                        ...val,
                        dataType: 'entry'
                    }))
                    openViewReport({
                        reportName: reportName + ` (${selReportType?.name} Summary)`,
                        criteriaHeaders,
                        criteriaData: [criteriaData],
                        tableData: data || [],
                        mainHeader: getMainHeader((selReportType?.id === 'bs' || selReportType?.id === 'cs') ? summaryColumnDefs : summaryColumnExempDefs),
                        isCSVRequired: true
                    })
                } else {
                    setShowAlert({ show: true, message: res?.ErrMessage })
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        } else {
            getGSTReturnDetailedReport(body).then((res) => {
                if (res.status === 'Success') {
                    if (res?.Data?.Table?.length === 0) {
                        setShowAlert({ show: true, message: 'No Data Found' })
                        return
                    }
                    let data = res?.Data?.Table?.map((val, i) => ({
                        ...val,
                        dataType: 'entry'
                    }))
                    openViewReport({
                        reportName: reportName + ` (${selReportType?.name} Detailed)`,
                        criteriaHeaders,
                        criteriaData: [criteriaData],
                        tableData: data || [],
                        mainHeader: getMainHeader(detailedColumnDefs),
                        isCSVRequired: true
                    })
                } else {
                    setShowAlert({ show: true, message: res?.ErrMessage })
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }
    //handle Close Alert
    const handleCloseAlert = () => {
        setShowAlert({ show: false, message: '' })
    }
    const reset = () => {
        setFromDate(moment(new Date()))
        setToDate(moment(new Date()))
        setselReportView(viewReport[0])
        setselReportType(reportTypeSummary[0])
        setIncludeBranches(false)
        if (companystatelist.length) {
            setSelState(companystatelist[0])
            getGSTAndBranch(companystatelist[0]?.StateID)
        }
    }
    function calcDiffDate(date1, date2) {
        var diff = Math.floor(date1.getTime() - date2.getTime());
        var day = 1000 * 60 * 60 * 24;
        var days = Math.floor(diff / day);
        return days
    }

    return (
        <Item sx={{ padding: '0' }} className="reports">
            <AcountingHeading reportName={reportName} />
            <Box sx={sx.reportFlex}>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.selectCompany}
                        label={lb.select_company}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        minWidth="250px"
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                        GO
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        label={`From Date`}
                        name={'from_date'}
                        dateDiff={calcDiffDate(new Date(), new Date("2021,04,01"))}
                        id={id.fromDate}
                        value={fromDate}
                        dateChange={(date) => {
                            setFromDate(date)
                            focusElemnt(id.toDate)
                        }}
                        width="210px"
                    />
                </Item>
                <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        label={'To Date'}
                        name={'to_date'}
                        id={id.toDate}
                        dateDiff={calcDiffDate(new Date(), new Date("2021,04,01"))}
                        value={toDate}
                        dateChange={(date) => {
                            setToDate(date)
                            focusElemnt(id.reportView)
                        }}
                        width="210px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.reportView}
                        label={lb.reportView}
                        data={viewReport}
                        defaultvalue={selReportView.name || selReportView}
                        value={selReportView.name || selReportView}
                        idKey={`id`}
                        dataKey={`name`}
                        onSelect={(val) => {
                            setselReportView(val)
                            if (val.id) {
                                setselReportType(reportTypeDetailed[0])
                            } else {
                                setselReportType(reportTypeSummary[0])
                            }
                        }}
                        isObjArr={true}
                        searchPlaceholder={`Search Report`}
                        width="210px"
                        nextId={id.reportType}
                        prevId={id.toDate}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.reportType}
                        label={lb.reportType}
                        data={selReportView.id === 1 ? reportTypeDetailed : reportTypeSummary}
                        defaultvalue={selReportType?.name}
                        idKey={`id`}
                        dataKey={`name`}
                        onSelect={(val) => {
                            setselReportType(val)
                        }}
                        isObjArr={true}
                        searchPlaceholder={`Search By Report Type`}
                        width="210px"
                        nextId={id.stateId}
                        prevId={id.reportView}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.stateId}
                        label={lb.selectState}
                        data={companystatelist}
                        defaultvalue={selState?.StateName || selState}
                        value={selState?.StateName || selState}
                        idKey={`StateID`}
                        dataKey={`StateName`}
                        onSelect={(val) => {
                            setSelState(val)
                            getGSTAndBranch(val.StateID)
                        }}
                        isObjArr={true}
                        searchPlaceholder={`Search State`}
                        width="200px"
                        nextId={id.includeBranches}
                        prevId={id.reportType}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <FormControlLabel
                        value="end"
                        checked={includeBranches}
                        onChange={() => {
                            setIncludeBranches(!includeBranches)
                        }}
                        onKeyDown={(e) => {
                            navigation3(e, includeBranches ? id.gstIn : id.reportmainButton, id.stateId, () => { })
                        }}
                        control={<Checkbox id={id.includeBranches} checked={includeBranches} />}
                        label={<Typography sx={{ fontWeight: '600', lineHeight: '18px', fontSize: '12px' }}>
                            Only Include Branches <br />Having GSTIN
                        </Typography>}
                        labelPlacement="end"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.gstIn}
                        label={lb.gstIn}
                        data={GSTOpt}
                        defaultvalue={selGST?.GSTIN || selGST}
                        value={selGST?.GSTIN || selGST}
                        idKey={`GSTIN`}
                        dataKey={`GSTIN`}
                        onSelect={(val) => {
                            setSelGST(val)
                        }}
                        isObjArr={true}
                        disabled={!includeBranches}
                        searchPlaceholder={`Search GSTIN`}
                        width="250px"
                        nextId={id.selectBranches}
                        prevId={id.includeBranches}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id={id.selectBranches}
                        label={lb.selectBranches}
                        data={branchOpt}
                        disabled={!includeBranches}
                        defaultvalue={selBranches?.BranchName || selBranches}
                        value={selBranches?.BranchName || selBranches}
                        idKey={`BranchID`}
                        dataKey={`BranchName`}
                        onSelect={(val) => {
                            setSelBranches(val)
                        }}
                        isObjArr={true}
                        searchPlaceholder={`Search Branches`}
                        width="240px"
                        nextId={id.reportmainButton}
                        prevId={id.gstIn}
                    />
                </Item>
                <Item sx={sx.itemsx}
                    onKeyDown={(e) => {
                        navigation3(e, id.fromDate, includeBranches ? id.selectBranches : id.includeBranches, () => {
                            generateReport()
                        })
                    }}
                >
                    <SplitButton
                        options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                        onClick1={generateReport}
                        hideToggle={true}
                        id1={id.reportmainButton}
                    />
                </Item>
                <Item sx={{ ...sx.itemsx }} onClick={reset}>
                    <RefreshSvg />
                </Item>
            </Box >
            {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
        </Item >
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getCompanyStateList, getCargoCompanyGSTList, getGSTReturnSummaryReport, getGSTReturnDetailedReport }
export default connect(mapStateToProps, mapDispatchToProps)(GSTReportReturnFile)
